<template>
  <div>
    <b-modal
        id="modal-add-new-form-item"
        ref="modal-add-new-form-item"
        footer-class="flex-nowrap"
        no-close-on-backdrop
        no-stacking
        centered
    >
      <template #modal-header>
        <h3>{{ $t('modals.createFormItem.title') }}</h3>
      </template>

      <template #default>
        <modal-choose-name-and-description
            :namePlaceholder="$t('modals.createFormItem.namePlaceholder')"
            :descriptionPlaceholder="$t('modals.createFormItem.descriptionPlaceholder')"
            @update-fields="updateFields"
            @enter-pressed="createFormItem"
        ></modal-choose-name-and-description>
      </template>

      <template #modal-footer>
        <b-button
            @click="closeAllModals"
            block
            class="p-3"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
            :disabled="!isFormItemNameSet"
            variant="primary"
            class="p-3"
            block
            @click="createFormItem"
        >
          {{ $t('modals.createFormItem.validate') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
// Template picking moved into the form builder itself (TemplateChooser in
// editor-v2) — this modal only asks for name/description and creates directly.
export default {
  name: 'ModalAddNewFormItem',
  components: {
    ModalChooseNameAndDescription: () => import('@/components/modals/ModalChooseNameAndDescription.vue'),
  },
  data: () => ({
    formItemName: null,
    formItemDescription: null,
  }),
  computed: {
    isFormItemNameSet() {
      return !!this.formItemName;
    },
  },
  methods: {
    closeAllModals() {
      this.$root.$emit('bv::hide::modal', 'modal-add-new-form-item');
    },
    updateFields(key, value) {
      if (key === 'name') {
        this.formItemName = value.trim();
      } else {
        this.formItemDescription = value.trim();
      }
    },
    createFormItem() {
      if (!this.isFormItemNameSet) return;
      this.$emit('create-form-item', { name: this.formItemName, desc: this.formItemDescription });
      this.$refs['modal-add-new-form-item'].hide();
    },
  },
};
</script>

<style lang="scss">
ul {
  list-style: none;
  font-size: 15px;
}

li a {
  font-size: 15px;
  font-weight: 600;
  background-color: transparent;

  &.active {
    color: #53dc86;
  }
}
.icon {
  position: relative;
  top: 4px;
}
</style>
